import * as React from 'react';
import { observable, action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Button, ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import { bind, inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import { IObjekt } from '../../models/ApiTypes';
import { ObjektListItem, ObjektListItemAuswahlCallback } from './ObjektListe';
import Pager from '../site/Pager';
import FilterBox from '../site/FilterBox';
import PagedList from '../site/PagedList';

interface IObjektAuswahlProps {
  kategorie?: string;
  onObjektAuswahl?: ObjektListItemAuswahlCallback;
}

@observer
export default class ObjektAuswahl extends PagedList<IObjektAuswahlProps> {

  @observable objekte: IObjekt[];
  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  async componentDidMount() {
    this.ladeObjekte();
  }

  async ladeObjekte() {
    const res = await this.apiStore.objekte(this.props.kategorie ? this.props.kategorie : 'alle', this.currentPage, this.filter);
    if (res.ok) {
      this.setLastPage(res.json.last_page);
      this.setObjekte(res.json.data);
    }
  }

  @action setObjekte(objekte: Array<IObjekt>) {
    this.objekte = objekte;
  }

  @bind @action paginate(pageNumber: number) {
    this.setCurrentPage(pageNumber);
    this.ladeObjekte();
  }

  @computed get objektBezeichner() {
    let kategorie: string = this.props.kategorie ? this.props.kategorie : '';
    switch (kategorie.toLocaleLowerCase()) {
      case 'ses':
        return 'Scheinwerfer-Einstellprüfgerät';
      case 'agt':
        return 'Abgasmessgerät';
      default:
        return 'Objekt';
    }
  }

  render() {
    let url = this.props.kategorie ? `anlegen/${this.props.kategorie}` : 'anlegen/';
    return (
      <div className="maxwidth">
        <h3>{this.objektBezeichner} auswählen</h3>
        <FilterBox onChange={this.handleFilterList} placeholder="Suchen (Kennung, Hersteller, Typbezeichnung, Bemerkung, Seriennr.)" />
        <Panel
          header={`Seite ${this.currentPage} von ${this.lastPage > 0 ? this.lastPage : 1}`}
          footer={(
            <div className="text-right">
              <Button onClick={() => this.uiStore.navigateBack()}>Abbrechen</Button>
              <Button bsStyle="success" onClick={() => this.uiStore.navigateTo(url)}>Neu</Button>
            </div>
          )}>
          <ListGroup fill={true}>
            {!this.objekte ? (
              <ListGroupItem>Objekte werden geladen...</ListGroupItem>
            ) : (this.objekte.length === 0) ? (
              <ListGroupItem>Keine Daten</ListGroupItem>
            ) : this.objekte.map(objekt => (
              <ObjektListItem
                key={objekt.objektguid}
                objekt={objekt}
                onObjektAuswahl={this.props.onObjektAuswahl}
                zusatzinfo={false}
              />
            ))}
          </ListGroup>
        </Panel>
        {this.objekte &&
          <div>
            <Pager
              items={this.lastPage}
              onSelect={this.paginate}
              activePage={this.currentPage}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/objekte/ObjektAuswahl.tsx